import { Grid, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquare } from '../../../assets/icons/add-square-green.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'
import { ReactComponent as Bag } from '../../../assets/icons/bag-button.svg'

import { ReactComponent as Rectangle } from '../../../assets/icons/Group 1686551338.svg'

import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import InputTextField from '../../../components/input/inputTextField';
import UploadFile from '../../../components/upload/UploadFile';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import { ThesisTypeApi } from '../../../api/thesis-type/thesis-type.api';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { ThesisBookApi } from '../../../api/thesis-book/thesis-book.api';
const defaultState = {
    id_examination_calendar: 0,
    examination_name: '',
    examination_desc: '',
    examination_start_date: undefined,
    examination_end_date: undefined,
    examination_calendar_start_date: undefined,
    examination_calendar_end_date: undefined,
    examination_calendar_status: "DRAFT",
    id_examination_calendar_files: []
}
export default function DetailEThesisLibrary() {
    const { t } = useTranslation();
    const location = useLocation()
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const mode = search_params.get("mode");
    const { id } = useParams();
    const [thesisType, setThesisType] = useState<any[]>([]);
    const [thesisCategory, setThesisCategory] = useState<any[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [form, setForm] = useState<any>(defaultState)
 

    const getThesisBook = async () => {
        
        const res = await ThesisBookApi.findById(id);
        const data = res.data
        if (data?.status < 300) {
            console.log(data);
            setForm(data.data)
        } else {
        }
    }
    const downloadfile = async (id:any, file_type:any) => {
        
        const res = await ThesisBookApi.downloadfile(id);
        if (res?.status < 300) {
            const blobFile = new Blob([res?.data], { type: file_type === 'pdf' ? 'application/pdf': file_type === 'xlsx' ?  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': file_type})
            const url = URL.createObjectURL(blobFile);
             window.open(url, '_blank');
        } else {
        }
    }
    const getThesisType = async () => {
        let condition: any = {
            page: 1,
            limit: 100
        };
        const res = await ThesisTypeApi.list(condition);
        const data = res.data
        if (data?.status < 300) {
            setThesisType(data?.data.items);

        } else {
        }
    }
    const getThesisCategory = async () => {
        let condition: any = {
            page: 1,
            limit: 100
        };
        const res = await ThesisCategoryApi.list(condition);
        const data = res.data
        if (data?.status < 300) {
            setThesisCategory(data?.data.items);

        } else {
        }
    }

    useEffect(() => {
        if (id) {
            getThesisBook()
        }
        getThesisCategory()
        getThesisType()
    }, [])


    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ห้องสมุดวิทยานิพนธ์"),
                        key: "1",
                        pathName: routeName.students.EThesisLibrary,
                    },
                    {
                        name: t("รายละเอียด E-Thesis"),
                        key: "2",
                        pathName: '/',
                    },

                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">รายละเอียด E-Thesis</Typography>
            </section>

            <section className="my-4">
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('ชื่อ')}
                            placeholder={t('ชื่อ')}
                            value={form?.thesis_book_name || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, thesis_book_name: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled

                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <FilterSelect
                            // value={inputValueSearch.year ?? ""}
                            heading={t('ประเภท')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={thesisType.map((item: any, index: number) => (
                                <MenuItem value={item.id_thesis_type} key={index + 1}>
                                    {item.thesis_type_name}
                                </MenuItem>
                            ))}
                            value={form?.id_thesis_type || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_thesis_type: e.target.value })
                            }}
                            disabled
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <FilterSelect
                            // value={inputValueSearch.year ?? ""}
                            heading={t('หมวดหมู่')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={thesisCategory.map((item: any, index: number) => (
                                <MenuItem value={item.id_thesis_category} key={index + 1}>
                                    {item.thesis_category_name}
                                </MenuItem>
                            ))}
                            value={form?.id_thesis_category || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_thesis_category: e.target.value })
                            }}
                            disabled
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={4}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('ชื่อนาม-สกุล ผู้จัดทำ')}
                            placeholder={t('ชื่อนาม-สกุล ผู้จัดทำ*')}
                            value={form?.thesis_book_created || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, thesis_book_created: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />

                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={4}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('ชื่อนาม-สกุล อาจารย์ที่ปรึกษาหลัก')}
                            placeholder={t('ชื่อนาม-สกุล อาจารย์ที่ปรึกษาหลัก')}
                            value={form?.thesis_book_advisor || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, thesis_book_advisor: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={4}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('ชื่อนาม-สกุล อาจารย์ที่ปรึกษาร่วม')}
                            placeholder={t('ชื่อนาม-สกุล อาจารย์ที่ปรึกษาร่วม')}
                            value={form?.thesis_book_co_advisor || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, thesis_book_co_advisor: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('รายละเอียด')}
                            placeholder={t('รายละเอียด')}
                            value={form?.thesis_book_desc || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, thesis_book_desc: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled
                            multiline
                            minRow={6}
                            inputHeight={'auto'}
                        />
                    </Grid>
                </Grid>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                    <Typography variant='h6'>{t("ไฟล์วิทยานิพนธ์ ฉบับสมบูรณ์")}</Typography>
                    {/* <AddSquare onClick={() => setForm({ ...form, files_thesis_book: form?.files_thesis_book?.length > 0 ? [...form?.files_thesis_book, {}] : [{}] })} /> */}
                </div>
                {form?.thesis_book?.map((item: any, index: number) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>


                                <div style={{
                                    border: "2px dotted #C1C3C7",
                                    borderRadius: "10px",
                                    padding: "15px 15px",
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <Document />
                                        <div style={{ display: "flex", alignItems: 'center' }}>
                                            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name || item?.name}</Typography>
                                            {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                                        </div>
                                    </div>

                                    <ButtonOutlined
                                        onClick={() => {
                                            // handleSubmit(inputValueFormStudent.information);
                                            // window.open(URL.createObjectURL(item), '_blank');
                                            // downloadfile(item?.id_thesis_book_file, item?.file_type)
                                            window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');

                                        }}
                                        buttonName={t('MEETING.DOWNLOAD_FILE')}
                                        btnProps={{
                                            width: "150px",
                                            // border: '#0F9F0C'
                                        }}
                                    />
                                </div>
                        </div>
                    )
                })}
            </section>


            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(routeName.students.EThesisLibrary);
                    }}
                    buttonName="ย้อนกลับ"
                    btnProps={{
                        width: "150px",
                    }}
                />


            </section>
        </div>
    )
}
